import {useEffect, useRef} from 'react'
import type {GenericContent} from '../../../../../../brand/lib/types/contentful'
import {animateFadeIn, type AnimationElement} from '../../_utils/animations'

import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'

import Styles from './Media.module.css'

type Props = {
  content: GenericContent
  location: string
  loading?: 'eager' | 'lazy'
}

export function Media(props: Props) {
  const {content, location, loading} = props

  const {media} = content.fields

  // Animation
  const wrapperRef = useRef<HTMLDivElement>(null)
  const assetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const elements: AnimationElement[] = []
    if (assetRef.current) elements.push({element: assetRef.current, animationType: 'asset'})

    if (wrapperRef.current) {
      return animateFadeIn(elements, wrapperRef.current)
    }
  }, [])

  return (
    <div className={Styles.Media} ref={wrapperRef}>
      {media && (
        <div ref={assetRef} data-animate="container">
          <div data-animate="item">
            <MediaAsset content={media} location={location} loading={loading} />
          </div>
          <div data-animate="cover" />
        </div>
      )}
    </div>
  )
}

try{ Media.displayName ||= 'Media' } catch {}